import { render, staticRenderFns } from "./recentRole.vue?vue&type=template&id=52896774&scoped=true"
import script from "./recentRole.vue?vue&type=script&lang=js"
export * from "./recentRole.vue?vue&type=script&lang=js"
import style0 from "./recentRole.vue?vue&type=style&index=0&id=52896774&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52896774",
  null
  
)

export default component.exports